import { getCurrentLocaleTransferCode } from "@user-center/utils/i18n";

const transferTextMap: Record<string, Record<string, string>> = {};

function normalizeLang(lang?: string): string {
  const raw = String(lang || "").trim();
  if (!raw) {
    return "";
  }
  const lower = raw.toLowerCase();
  if (lower === "zh-tw" || lower === "zh_hant" || lower === "zh-hant") {
    return "zh-tw";
  }
  return lower;
}

export function setTransferTextMap(
  targetLanguage: string,
  mapData: Record<string, string>
): void {
  const lang = normalizeLang(targetLanguage);
  if (!lang || !mapData || typeof mapData !== "object") {
    return;
  }
  if (!transferTextMap[lang]) {
    transferTextMap[lang] = {};
  }
  transferTextMap[lang] = {
    ...transferTextMap[lang],
    ...mapData,
  };
}

export function getTransfersTextByKey(key: string): string {
  const textKey = String(key || "");
  if (!textKey) {
    return "";
  }
  const currentLang = normalizeLang(getCurrentLocaleTransferCode());
  const currentMap = transferTextMap[currentLang] || {};
  return currentMap[textKey] || textKey;
}
